const SET_USIS_DATA = 'SET_USIS_DATA';
const SET_USIS_MODAL_STEP = 'SET_USIS_MODAL_STEP';
const SET_USIS_COMMON_MODAL_STEP = 'SET_USIS_COMMON_MODAL_STEP';
const TOGGLE_USIS_MODAL_OPEN = 'TOGGLE_USIS_MODAL_OPEN';
const TOGGLE_USIS_COMMON_MODAL_OPEN = 'TOGGLE_USIS_COMMON_MODAL_OPEN';
const CLOSE_USIS_CONFIRM_DEACTIVATE_MODAL = 'CLOSE_USIS_CONFIRM_DEACTIVATE_MODAL';
const OPEN_USIS_CONFIRM_DEACTIVATE_MODAL = 'OPEN_USIS_CONFIRM_DEACTIVATE_MODAL';
const WAITING_REQUEST = 'WAITING_REQUEST';
const SET_IS_FETCH_ERROR = 'SET_IS_FETCH_ERROR';
const SET_MODAL_VARIANT = 'SET_MODAL_VARIANT';

const ADD_NOTIFICATION_PD = 'ADD_NOTIFICATION_PD';
const REMOVE_NOTIFICATION_PD = 'REMOVE_NOTIFICATION_PD';

const SET_IS_ONLY_ONCE_VARIANT_UPD = 'SET_IS_ONLY_ONCE_VARIANT_UPD';

/**
 *
 * @param {any} - данные, которые сохраняются после вызова lk-update-personal-info
 * @returns {Function}
 */
const setUsisData = (payload) => (dispatch) => {
  dispatch({
    type: SET_USIS_DATA,
    payload,
  });
};

/**
 *
 * @param {string} - string из ESIA_USIS_MODAL_STEPS
 * @returns {Function}
 */
const setUsisModalStep = (payload) => (dispatch) => {
  dispatch({
    type: SET_USIS_MODAL_STEP,
    payload,
  });
};

/**
 *
 * @param {string} - string из ESIA_USIS_MODAL_STEPS
 * @returns {Function}
 */
const setUsisCommonModalStep = (payload) => (dispatch) => {
  dispatch({
    type: SET_USIS_COMMON_MODAL_STEP,
    payload,
  });
};

/**
 *
 * @param {boolean} - true\false
 * @returns {Function}
 */
const toggleUsisModal = (payload) => (dispatch) => {
  dispatch({
    type: TOGGLE_USIS_MODAL_OPEN,
    payload,
  });
};

/**
 *
 * @param {boolean} - true\false
 * @returns {Function}
 */
const toggleUsisCommonModal = (payload) => (dispatch) => {
  dispatch({
    type: TOGGLE_USIS_COMMON_MODAL_OPEN,
    payload,
  });
};

/**
 *
 * @param {boolean} - true\false
 * @returns {Function}
 */
const closeUsisConfirmDeactivateModal = () => (dispatch) => {
  dispatch({
    type: CLOSE_USIS_CONFIRM_DEACTIVATE_MODAL,
  });
};

/**
 *
 * @param {boolean} - true\false
 * @returns {Function}
 */
const openUsisConfirmDeactivateModal = () => (dispatch) => {
  dispatch({
    type: OPEN_USIS_CONFIRM_DEACTIVATE_MODAL,
  });
};

/**
 *
 * @param {boolean} - true\false
 * @returns {Function}
 */
const setWaitingRequest = (payload) => (dispatch) => {
  dispatch({
    type: WAITING_REQUEST,
    payload,
  });
};

/**
 *
 * @param {boolean} - true\false
 * @returns {Function}
 */
const setIsFetchError = (payload) => (dispatch) => {
  dispatch({
    type: SET_IS_FETCH_ERROR,
    payload,
  });
};

/**
 *
 * @param {string} - string из RADIO_VALUES
 * @returns {Function}
 */
const setModalVariant = (payload) => (dispatch) => {
  dispatch({
    type: SET_MODAL_VARIANT,
    payload,
  });
};

const addNotificationPD = (payload) => (dispatch) => {
  dispatch({
    type: ADD_NOTIFICATION_PD,
    payload,
  });
};

const removeNotificationPD = (payload) => (dispatch) => {
  dispatch({
    type: REMOVE_NOTIFICATION_PD,
    payload,
  });
};

/**
 *
 * @param {boolean} - true\false
 * @returns {Function}
 */
const setIsOnlyOnceVariantUpd = (payload) => (dispatch) => {
  dispatch({
    type: SET_IS_ONLY_ONCE_VARIANT_UPD,
    payload,
  });
};

export {
  SET_USIS_DATA,
  SET_USIS_MODAL_STEP,
  TOGGLE_USIS_MODAL_OPEN,
  CLOSE_USIS_CONFIRM_DEACTIVATE_MODAL,
  OPEN_USIS_CONFIRM_DEACTIVATE_MODAL,
  WAITING_REQUEST,
  SET_IS_FETCH_ERROR,
  SET_MODAL_VARIANT,
  TOGGLE_USIS_COMMON_MODAL_OPEN,
  SET_USIS_COMMON_MODAL_STEP,
  ADD_NOTIFICATION_PD,
  REMOVE_NOTIFICATION_PD,
  SET_IS_ONLY_ONCE_VARIANT_UPD,
  setUsisData,
  setUsisModalStep,
  toggleUsisModal,
  setWaitingRequest,
  closeUsisConfirmDeactivateModal,
  openUsisConfirmDeactivateModal,
  setIsFetchError,
  setModalVariant,
  toggleUsisCommonModal,
  setUsisCommonModalStep,
  addNotificationPD,
  removeNotificationPD,
  setIsOnlyOnceVariantUpd,
};
